module.exports = __webpack_public_path__ + "img/5.f44f57e0.jpg";